export default {
  kea: {
    card: 'KEA kortið',
    about: 'Um KEA',
    offers: 'KEA kjör',
    location: 'Glerárgötu 36',
    address: '600 Akureyri, IS',
    phone: 'Sími: 460 3400',
    fax: 'Fax: 460 3401',
    ssn: 'Kt: 680169-3401',
    email: 'kea@kea.is'
  },
  map: {
    distance: 'Fjarlægð:',
    kilometers: 'km'
  },
  navigation: {
    card: 'Sýna KEA Kortið',
    affiliates: 'Tilboðin',
    map: 'Tilboð nálægt þér',
    notifications: 'Fá tilkynningar',
    contact: 'Hafa samband',
    terms: 'Skilmálar',
    logout: 'Útskráning'
  },
  categories: {
    all: 'Allir flokkar'
  },
  card: {
    userRequired: 'Notandi þarf að vera innskráður til að hægt sé að birta KEA kortið.'
  },
  affiliate: {
    phone: 'Sími:',
    viewOnMap: 'Sjá á korti'
  },
  affiliates: {
    footer: {
      openLink: 'Opna vefsíðu',
      viewOnMap: 'Sjá á korti',
      favorite: 'Uppáhalds'
    },
    title: 'ALMENN TILBOÐ TIL KORTHAFA',
    viewOnMap: 'Skoða á korti',
    allOffers: 'Öll tilboð'
  },
  favorites: {
    title: 'Uppáhalds',
    uppercaseTitle: 'UPPÁHALDS'
  },
  specials: {
    daysLeft: 'dagar eftir',
    title: 'TÍMABUNDIN SÉRTILBOÐ',
    valid: 'Gildir til',
    readMore: 'Lesa meira'
  },
  login: {
    electricId: {
      title: 'Innskráning með rafrænu skilríki í farsíma',
      noElectricID: 'Ekki með rafræn skilríki?',
      phoneNumber: 'Símanúmer'
    },
    SSN: {
      title: 'Innskráning með kennitölu',
      noSSN: 'Innskrá með rafrænum skilríkjum',
      SSN: 'Kennitala',
      password: 'Lykilorð'
    },
    errors: {
      title: 'Villa',
      resendEmail: {
        title: 'Smelltu hér til að endursenda lykilorð'
      },
      noMemberFound: {
        title: 'Villa',
        message: 'Þessi kennitala er ekki skráð í félagagrunninn.' + 'Ef þú vilt sækja um félagsaðild þá getur þú sótt um hér ',
        membership: 'Sækja um KEA kort',
        disclaimer: 'Vinsamlegast athugið að það getur tekið 2-3 daga að verða félagi.'
      },
      memberPasswordSentWithEmail: {
        title: 'Tölvupóstur sendur',
        message: 'Póstur með lykilorði hefur verið sendur á netfangið ',
        wrongEmail: '. Ef þetta netfang er ekki rétt þá vinsamlegast hafðu samband við KEA til að uppfæra netfangið.',
        noEmail: 'Ekkert póstfang fannst sem tengist þessum notanda. Vinsamlegast hafðu samband við KEA til að skrá póstfangið þitt.',
        contact: 'Hafa samband',
        close: 'Netfang er rétt. Loka glugga.'
      },
      wrongPassword: {
        invalidInput: 'Lykilorð er ekki rétt'
      },
      password: {
        invalidInput: 'Lykilorð þarf að vera lengra en sjö stafir',
        noInput: 'Vinsamlegast settu inn lykilorð'
      },
      phone: {
        noInput: 'Vinsamlegast settu inn símanúmer',
        invalidInput: 'Símanúmer þarf að vera sjö stafir'
      },
      SSN: {
        invalidInput: 'Kennitala þarf að vera tíu stafir',
        noInput: 'Vinsamlegast settu inn kennitölu'
      }
    }
  },
  user: {
    dialog: {
      loggedOut: {
        title: 'Útskráningu lokið',
        message: 'Til að njóta afslátta KEA kortsins þarftu að skrá þig inn aftur.'
      }
    }
  },
  dialog: {
    ok: 'Loka',
    showSpecial: 'Skoða tilboð'
  },
  api: {
    error: {
      noMemberFound: {
        title: 'Villa.',
        message: 'Þessi kennitala er ekki skráð í félagagrunninn. ' + 'Ef þú vilt sækja um félagsaðild þá getur þú sótt um með því að smella á takkann hér að neðan. '
      },
      memberPasswordSentWithEmail: {
        title: 'Tölvupóstur sendur',
        message: 'Póstur með lykilorði hefur verið sendur á netfangið ',
        wrongEmail: '. Ef þetta netfang er ekki rétt þá vinsamlegast hafðu samband við KEA til að uppfæra netfangið.',
        noEmailTitle: 'Villa.',
        noEmail: 'Ekkert póstfang fannst sem tengist þessum notanda. Vinsamlegast hafðu samband við KEA til að skrá póstfangið þitt.'
      },
      memberPasswordInvalid: {
        title: 'Rangt lykilorð',
        message: 'Lykilorð er rangt. Vinsamlegast reyndu aftur.'
      },
      memberHasNoEmailAddress: {
        title: 'Ekkert netfang skráð',
        message: 'Ekkert netfang hefur verið skráð fyrir þennan félagsmann. Vinsamlegast hafðu samband við KEA'
      },
      memberNotActive: {
        title: 'Félagsmaður er óvirkur',
        message: 'Ekki er hægt að skrá inn þennan félagsmann.'
      },
      userNotFound: {
        title: 'Notandi er ekki innskráður',
        message: 'Vinsamlegast skráðu þig inn.'
      },
      affiliateNotFound: {
        title: 'Oops!',
        message: 'Samstarfsaðili fannst ekki.'
      },
      categoryNotFound: {
        title: 'Oops!',
        message: 'Flokkur fannst ekki.'
      },
      specialNotFound: {
        title: 'Oops!',
        message: 'Sértilboð fannst ekki.'
      },
      pageNotFound: {
        title: 'Oops!',
        message: 'Síða fannst ekki.'
      },
      pageNoCodename: {
        title: 'Oops!',
        message: 'Engin síða skilgreind'
      },
      missingAccessToken: {
        title: 'Notandi er ekki innskráður',
        message: 'Vinsamlegast skráðu þig inn.'
      },
      networkError: {
        title: 'Villa',
        message: 'Tenging náðist ekki, reyndu aftur síðar.'
      },
      authenticationWithMobileIdFailed: {
        title: 'Villa',
        message: 'Notandi hætti við.'
      },
      authenticationWithMobileIdTimedOut: {
        title: 'Villa',
        message: 'Aðgerð rann út á tíma.'
      }
    }
  },
  route: {
    error: {
      pageNotFound: 'Síða fannst ekki...',
      goBack: 'Til baka',
      errorCode: '404'
    }
  }
};